import { defineModule } from "@motolynk/app-core";

import en from "./i18n/en.json";

/** Feature-flag plumbing lives in @motolynk/app-core (useFeature, <Feature>, route/nav `feature`). */
export const configurationModule = defineModule({
  name: "configuration",
  label: "Settings & feature flags",
  requires: ["core", "geo", "accounts"],
  i18n: { en },
  admin: {
    routes: [
      {
        path: "settings",
        permission: "configuration.view_marketplacesettings",
        page: () => import("./admin/SettingsPage"),
      },
      {
        path: "settings/footer",
        permission: "configuration.view_footerlink",
        page: () => import("./admin/FooterPage"),
      },
      {
        path: "settings/features",
        permission: "configuration.view_featureflag",
        page: () => import("./admin/FlagsPage"),
      },
    ],
    nav: [
      {
        id: "settings",
        group: "settings",
        label: "configuration:nav.settings",
        icon: "settings",
        to: "/settings",
        permission: "configuration.view_marketplacesettings",
        order: 1,
      },
      {
        id: "footer",
        group: "settings",
        label: "configuration:nav.footer",
        icon: "list",
        to: "/settings/footer",
        permission: "configuration.view_footerlink",
        order: 1.5,
      },
      {
        id: "feature-flags",
        group: "settings",
        label: "configuration:nav.flags",
        icon: "filter",
        to: "/settings/features",
        permission: "configuration.view_featureflag",
        order: 2,
      },
    ],
  },
  vendor: { routes: [], nav: [] },
});
